import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { SagaIterator } from 'redux-saga';

// Constants
import { RESET_PASSWORD_LOAD_REQUESTED } from './constants';

// Actions
import { resetPasswordSucceeded, resetPasswordFailed } from './actions';

// Environment
const REACT_APP_API_URL = String(process.env.REACT_APP_API_URL);

const NOT_FOUND = 422;

export function* postResetPassword(payload: any): SagaIterator {
    const url = `${REACT_APP_API_URL}/v1/Users/resetPassword`;
    const config = { email: payload.email };

    try {
        yield call(axios.post, url, config);

        yield put(resetPasswordSucceeded());
    } catch (error) {
        if (error && error.response && error.response.status === NOT_FOUND) {
            yield put(resetPasswordSucceeded());
        } else {
            yield put(
                resetPasswordFailed(
                    'Oops, something unexpected went wrong. Please try again.'
                )
            );
        }
    }
}

export function* watchResetPassword(): SagaIterator {
    yield takeLatest(RESET_PASSWORD_LOAD_REQUESTED, postResetPassword);
}
